import React, { useMemo } from 'react';
import Header from "components/Header/Header.js";
import HomeFooter from "components/Footer/HomeFooter.js";
import HeaderLinks from "components/Header/HeaderLinks.js";
import Hero from "../components/Hero";
import ServicesSection from "../components/ServicesSection";
import OffersSection from "../components/OffersSection";
import AboutSection from "../components/AboutSection";
import DestinationsSection from "../components/DestinationsSection";
import TestimonialsSection from "../components/TestimonialsSection";
import StatsSection from "../components/StatsSection";
import FAQSection from "../components/FAQSection";
import Download from "../components/Download";
import ParticlesBackground from "../components/ParticlesBackground";
import FleetSlider from "../components/FleetSlider";
import PartnersPromoSlider from "../components/PartnersPromoSlider";
import DriverRecruitmentBanner from "../components/DriverRecruitmentBanner";
import AppDownloadBanner from "../components/AppDownloadBanner";
import LandingActionPanel from "../components/LandingActionPanel";
import GaelleFeatureSection from "../components/GaelleFeatureSection";
import Chatbot from "../components/Chatbot/Chatbot";
import EatRestaurantsSlider from "../components/EatRestaurantsSlider";
import AnimatedSectionNav from "../components/AnimatedSectionNav";
import { useSelector } from "react-redux";

const dashboardRoutes = [];

const LandingPage = (props) => {
  const { ...rest } = props;
  
  // Optimisation: utiliser selector direct au lieu de state local
  const role = useSelector(state => state.auth?.profile?.usertype);
  
  // Mémoïser la config du header pour éviter re-renders
  const headerConfig = useMemo(() => ({
    height: 400,
    color: "primary"
  }), []);

  return (
    <div style={{ backgroundColor: '#000', position: 'relative' }}>
      {/* Background avec particules */}
      <ParticlesBackground />

      {/* Navigation verticale animée (desktop uniquement) */}
      <AnimatedSectionNav />
      
      {/* Contenu de la page */}
      <div style={{ position: 'relative', zIndex: 1 }}>
        <Header
          color="transparent"
          routes={dashboardRoutes}
          rightLinks={<HeaderLinks />}
          fixed
          changeColorOnScroll={headerConfig}
          {...rest}
        />
        
        {/* Hero Section */}
        <div id="section-hero">
          <Hero role={role} />
        </div>
        
        {/* IA WhatsApp — Gaëlle feature highlight */}
        <GaelleFeatureSection />
        
        {/* App Download Banner - Direct sous le Hero */}
        <AppDownloadBanner />
        
        {/* Accès rapides */}
        <LandingActionPanel />
        
        {/* Services Section */}
        <div id="section-services">
          <ServicesSection />
        </div>

        {/* Restaurants partenaires Allô Driver Eats */}
        <EatRestaurantsSlider />
        
        {/* About Section */}
        <div id="section-about">
          <AboutSection />
        </div>
        
        {/* Offers Section */}
        <OffersSection />
        
        {/* Destinations Section */}
        <DestinationsSection />
        
        {/* Fleet Slider */}
        <div id="section-fleet">
          <FleetSlider />
        </div>
        
        {/* Testimonials Section */}
        <div id="section-testimonials">
          <TestimonialsSection />
        </div>
        
        {/* Stats Section */}
        <StatsSection />
        
        {/* FAQ Section */}
        <div id="section-faq">
          <FAQSection />
        </div>
        
        {/* Download App Section - Full version avec vidéo */}
        <div id="section-download">
          <Download />
        </div>

        {/* Driver Recruitment Banner */}
        <DriverRecruitmentBanner />

        {/* Partners Promo Slider - Eden Auto & MMA */}
        <PartnersPromoSlider />

        <HomeFooter />

        {/* Chatbot */}
        <Chatbot />
      </div>
    </div>
  );
};

export default React.memo(LandingPage);
